import { NonNormalizedSpaceType } from './spaces.types';

export const normalizeSpacePath = (space: NonNormalizedSpaceType) => ({
  ...space,
  path: space?.path === '' ? [] : space.path.split('.').map((i) => parseInt(i)),
});
